import axios from "@/axios.js"

export default {
  searchSteps({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/campaigns/master_steps/search_step/" + item)
        .then((response) => {
          commit('SET_STEPS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/steps/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSteps({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/master_steps/update_master_step", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addSteps({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/master_steps/add_steps", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllMasterSteps({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/campaigns/master_steps/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_STEPS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllStepsWithFilter({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/campaigns/master_steps/steps_with_filter", {
          item: item
        })
        .then((response) => {
          commit('SET_STEPS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSteps(context, stepId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/master_steps/${stepId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchStepsList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/campaigns/master_steps/${item}`)
        .then((response) => {
          commit('SELECTED_STEPS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeSteps({
    commit
  }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios.delete(`/api/campaigns/master_steps/${roleId}`)
        .then((response) => {
          commit('REMOVE_STEPS', roleId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
